import * as THREE from "three";
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import fragment from "./shader/fragment.glsl";
import vertex from "./shader/vertex.glsl";
// import GUI from 'lil-gui'; 

var colors = require('nice-color-palettes');
let ind = Math.floor(Math.random() * colors.length)
ind = 25;
console.log(ind)
let pallete = colors[ind];

// const gold = '#dec982' //{isColor:true, r:0.8705882352941177, g:0.788235294117647, b:0.5098039215686274}; //
const gold = '#f2de9c' //{isColor:true, r:0.8705882352941177, g:0.788235294117647, b:0.5098039215686274}; //
// const purple = '#b194be' //{isColor:true, r:0.6941176470588235, g:0.5803921568627451, b:0.7450980392156863}; //
const purple = '#dcbaeb' //{isColor:true, r:0.6941176470588235, g:0.5803921568627451, b:0.7450980392156863}; //
const fluo = '#e3fb60' //{isColor:true, r:0.8901960784313725, g:0.984313725490196, b:0.3764705882352941}; //
// const green = '#398240' //{isColor:true, r:0.2235294117647059, g:0.5098039215686274, b:0.25098039215686274}; //
const green = '#79cd81' //{isColor:true, r:0.2235294117647059, g:0.5098039215686274, b:0.25098039215686274}; //
// const blue = '#a7f4e5' //{isColor:true, r:0.6549019607843137, g:0.9568627450980393, b:0.8980392156862745}; //
const blue = '#d4fff7' //{isColor:true, r:0.6549019607843137, g:0.9568627450980393, b:0.8980392156862745}; //

const customColors = [gold,purple,fluo,green,blue];

pallete = customColors.map((color) => new THREE.Color(color))
console.log(pallete);



export default class Sketch {
  constructor(options) {
    this.scene = new THREE.Scene();

    this.container = options.dom;
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer = new THREE.WebGLRenderer();
    this.renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    this.renderer.setSize(this.width, this.height);
    this.renderer.setClearColor(0xeeeeee, 1); 
    this.renderer.physicallyCorrectLights = true;
    this.renderer.outputEncoding = THREE.sRGBEncoding;

    this.container.appendChild(this.renderer.domElement);

    // this.camera = new THREE.PerspectiveCamera(
    //   70,
    //   this.width / this.height,
    //   0.001,
    //   1000
    // );
    this.camera = new THREE.OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );


    // var frustumSize = 10;
    // var aspect = window.innerWidth / window.innerHeight;
    // this.camera = new THREE.OrthographicCamera( frustumSize * aspect / - 2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / - 2, -1000, 1000 );
    this.camera.position.set(0, 0, .4);
    this.camera.lookAt(0, 0, 0);
    // this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.time = 0;

    // this.dracoLoader = new DRACOLoader();
    // this.dracoLoader.setDecoderPath('https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/js/libs/draco/'); // use a full url path
    // this.gltf = new GLTFLoader();
    // this.gltf.setDRACOLoader(this.dracoLoader);

    this.isPlaying = true;
    
    this.addObjects();
    this.resize();
    this.render();
    this.setupResize();
    // this.settings();
  }

  settings() {
    let that = this;
    this.settings = {
      progress: 0,
    };
    // this.gui = new GUI();
    // this.gui.add(this.settings, "progress", 0, 1, 0.01);
  }

  setupResize() {
    window.addEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer.setSize(this.width, this.height);
    this.camera.aspect = this.width / this.height;
    
    if ( this.width > this.height ) this.plane.scale.set(1, this.width / this.height), 1;
    else this.plane.scale.set(1, this.height / this.width), 1;

    this.camera.updateProjectionMatrix();


  }

  addObjects() {
    let that = this;
    this.material = new THREE.ShaderMaterial({
      extensions: {
        derivatives: "#extension GL_OES_standard_derivatives : enable"
      },
      side: THREE.DoubleSide,
      uniforms: {
        time: { value: 0 },
        uColor: { value: pallete },
        resolution: { value: new THREE.Vector4() },
      },
      // wireframe: true,
      // transparent: true,
      vertexShader: vertex,
      fragmentShader: fragment
    });

    this.geometry = new THREE.PlaneGeometry(2, 2, 300, 300);
    this.plane = new THREE.Mesh(this.geometry, this.material);
    this.scene.add(this.plane);
  }

  addLights() {
    const light1 = new THREE.AmbientLight(0xffffff, 0.5);
    this.scene.add(light1);

    const light2 = new THREE.DirectionalLight(0xffffff, 0.5);
    light2.position.set(0.5, 0, 0.866); // ~60º
    this.scene.add(light2);
  }

  stop() {
    this.isPlaying = false;
  }

  play() {
    if(!this.isPlaying){
      this.isPlaying = true;
      this.render()
    }
  }

  render() {
    if (!this.isPlaying) return;
    this.time += 0.0002;
    this.material.uniforms.time.value = this.time;
    requestAnimationFrame(this.render.bind(this));
    this.renderer.render(this.scene, this.camera);
  }
}

new Sketch({
  dom: document.getElementById("colors")
});
